module.exports = __webpack_public_path__ + "static/tcal.3bd7692b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/papers/tcal.pdf
// module id = 396
// module chunks = 35783957827783